import { useState } from 'react'
import { AlertTriangle } from 'lucide-react'
import { DISCLAIMER_TEXTS } from '../lib/disclaimer'
import { useI18n } from '../lib/i18n'

interface Props {
  open: boolean
  actionType: 'save' | 'export_word' | 'export_pdf'
  onConfirm: () => void
  onCancel: () => void
}

export function AIConfirmModal({ open, actionType, onConfirm, onCancel }: Props) {
  const { lang } = useI18n()
  const l = lang === 'zh' ? 'zh' : 'en'
  const [checked, setChecked] = useState(false)

  if (!open) return null

  const actionLabel =
    actionType === 'save'
      ? l === 'zh' ? '保存' : 'save'
      : actionType === 'export_word'
        ? l === 'zh' ? '导出 Word' : 'export Word'
        : l === 'zh' ? '导出 PDF' : 'export PDF'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-lg border border-brand-200 w-full max-w-md mx-4 p-6">
        <div className="flex items-center gap-2 mb-4">
          <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
          <h3 className="text-base font-semibold text-brand-800">
            {DISCLAIMER_TEXTS.modalTitle[l]}
          </h3>
        </div>

        <p className="text-sm text-brand-600 leading-relaxed mb-4">
          {l === 'zh'
            ? `您即将${actionLabel}一份由人工智能辅助生成的材料。请确认您已审阅内容并对其使用负责。`
            : `You are about to ${actionLabel} an AI-assisted material. Please confirm you have reviewed the content and will remain responsible for its use.`}
        </p>

        <label className="flex items-start gap-2.5 cursor-pointer mb-5">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5 w-4 h-4 rounded border-brand-300 text-blue-600 focus:ring-blue-400 flex-shrink-0"
          />
          <span className="text-sm text-brand-700 leading-relaxed">
            {DISCLAIMER_TEXTS.confirmCheckbox[l]}
          </span>
        </label>

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={() => {
              setChecked(false)
              onCancel()
            }}
            className="px-4 py-2 rounded-lg text-sm font-medium text-brand-600 hover:bg-brand-50 transition-colors"
          >
            {DISCLAIMER_TEXTS.modalCancelBtn[l]}
          </button>
          <button
            type="button"
            disabled={!checked}
            onClick={() => {
              onConfirm()
              setChecked(false)
            }}
            className="px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          >
            {DISCLAIMER_TEXTS.modalConfirmBtn[l]}
          </button>
        </div>
      </div>
    </div>
  )
}
